import axios from "axios";
const userActivityApi = process.env.REACT_APP_INVOICE_USER_ACTIVITY_CONFIG;

export const downloadActivity = async (data) => {
    const path = '/userFileDownloadActivity';
    const queryParams = `?user_id=${localStorage.getItem('user_id')}`;
    data.company = localStorage.getItem('companyName');
    console.log(data);
    try {
        const response = await axios.post(userActivityApi + path + queryParams, data);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const documentSentActivity = async (data) => {
    const path = '/userDocumentSentActivity';
    const queryParams = `?user_id=${localStorage.getItem('user_id')}`;
    try {
        const response = await axios.post(userActivityApi + path + queryParams, data);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const createInvoiceActivity = async (data) => {
    const path = '/userCreateInvoiceActivity';
    try {
        const response = await axios.post(userActivityApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to load create invoice activity';
    }
};

export const documentExportedActivity = async (data) => {
    const path = '/userExportSummaryActivity';
    const queryParams = `?user_id=${localStorage.getItem('user_id')}`;
    try {
        const response = await axios.post(userActivityApi + path + queryParams, data);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const userLoginActivity = async () => {
    const path = '/userLoginActivity';
    const queryParams = `?user_id=${localStorage.getItem('user_id')}`;
    const data = {
        "company": localStorage.getItem('companyName'),
        "login_date": new Date()
    };
    try {
        const response = await axios.post(userActivityApi + path + queryParams, data);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const getUserActivityDetails = async () => {
    const path = '/userDetails';
    const queryParams = `?user_id=${localStorage.getItem('user_id')}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const getUserLoginActivityDetails = async (userId, dateRange) => {
    console.log("dateRange", dateRange);
    const path = '/userLoginActivity';
    let queryParams = `?user_id=${userId}`;
    
    // Add dateRange to queryParams if it's provided
    if (dateRange) {
        queryParams += `&dateRange=${dateRange}`;
    }

    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        console.log(response);
        return response;
    } catch (error) {
        console.error('Error fetching the user login activity details', error);
        return 'Unable to load details';
    }
};


export const getUserDownloadActivityDetails = async (userId) => {
    const path = '/userFileDownloadActivity';
    const queryParams = `?user_id=${userId}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const getUserDocumentSentActivityDetails = async (userId) => {
    const path = '/userDocumentSentActivity';
    const queryParams = `?user_id=${userId}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const getUserCreateInvoiceActivityDetails = async (userId) => {
    const path = '/userCreateInvoiceActivity';
    const queryParams = `?user_id=${userId}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const getUserDocumentExportedActivityDetails = async (userId) => {
    const path = '/userExportSummaryActivity';
    const queryParams = `?user_id=${userId}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        console.log(response);
        return response;
    } catch (error) {
        return 'Unable to load details';
    }
};

export const getUserDetails = async (userId) => {
    const path = '/user';
    const queryParams = `?user_id=${userId}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        if (response.length === 1) {
            localStorage.setItem('userDetails', response[0]);
        }
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const getAllUsers = async () => {
    const path = '/user';
    try {
        const response = await axios.get(userActivityApi + path);
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};

export const sendInvite = async (data) => {
    try {
        console.log("data", data);
        const path = "/invite";
        const response = await axios.post(userActivityApi + path, data);
        return response;
    } catch (error) {
        return 'Unable to send invite';
    }
};

export const getCompanyDetails = async () => {
    try {
        let path = `/companies`;
        const response = await axios.get(userActivityApi + path);
        return response;
    } catch (error) {
        return "Unable to fetch company details";
    }
};

export const getCompaniesList = async () => {
    try {
        const path = '/filters/companies';
        const response = await axios.get(userActivityApi + path);
        return response;
    } catch (error) {
        console.error('Error fetching the company list:', error);
        throw error;
    }
};

export const getUsageMetrics = async (dateRange, company) => {
    try {
        const path = '/dashboard/usageMetrics';
        let queryString = `?dateRange=${dateRange}`;
        if (company && company !== 'allCustomers') {
            queryString += `&company=${company}`;
        }
        const response = await axios.get(userActivityApi + path + queryString);
        return response;
    } catch (error) {
        console.error('Error fetching the usageMetrics', error);
        throw error;
    }
};

export const getDocumentMetrics = async (dateRange, company, userId) => {
    try {
        const path = '/dashboard/documentMetrics';
        let queryString = `?dateRange=${dateRange}`;
        if (company && company !== 'allCustomers') {
            queryString += `&company=${company}`;
            if (userId && userId !== 'allUsers') {
                queryString += `&userId=${userId}`;
            }
        }
        const response = await axios.get(userActivityApi + path + queryString);
        return response;
    } catch (error) {
        console.error('Error fetching the documentMetrics', error);
        throw error;
    }
};

export const getUserMetrics = async (dateRange, company) => {
    try {
        const path = '/dashboard/userMetrics';
        let queryString = `?dateRange=${dateRange}`;
        if (company && company !== 'allCustomers') {
            queryString += `&company=${company}`;
        }
        const response = await axios.get(userActivityApi + path + queryString);
        return response;
    } catch (error) {
        console.error('Error fetching the userMetrics', error);
        throw error;
    }
};

export const getTextractMetrics = async () => {
    try {
        const path = '/dashboard/textractMetrics';
        const response = await axios.get(userActivityApi + path);
        return response;
    } catch (error) {
        console.error('Error fetching the textractMetrics', error);
        throw error;
    }
};

export const getDocTableMetrics = async (dateRange, company, userId) => {
    console.log("userId inside docTable metrics func", userId);
    try {
        const path = '/dashboard/docTableMetrics';
        let queryString = `?dateRange=${dateRange}`;
        if (company && company !== 'allCustomers') {
            queryString += `&company=${company}`;
            if (userId && userId !== 'allUsers') {
                queryString += `&userId=${userId}`;
            }
        }
        const response = await axios.get(userActivityApi + path + queryString);
        return response;
    } catch (error) {
        console.error('Error fetching the docTableMetrics', error);
        throw error;
    }
};

export const getRoleMetrics = async (company) => {
    try {
        const path = '/dashboard/roleMetrics';
        let fullPath = userActivityApi + path;
        if (company && company !== 'allCustomers') {
            fullPath += `?company=${company}`;
        }
        const response = await axios.get(fullPath);
        return response;
    } catch (error) {
        console.error('Error fetching the roleMetrics', error);
        throw error;
    }
};

export const getUserDetailsByCompany = async (company) => {
    const path = '/company/user';
    const queryParams = `?company_name=${company}`;
    try {
        const response = await axios.get(userActivityApi + path + queryParams);
        if (response.length === 1) {
            localStorage.setItem('userDetails', response[0]);
        }
        return response;
    } catch (error) {
        return 'Unable to load user details';
    }
};
